<template>
    <draggable v-model="files" class="row no-gutters" draggable=".image-item" @change="emit">
        <v-col v-for="{ file, src } in images" :key="file?.name" class="image-item" style="cursor: pointer" v-bind="{ cols, sm, md, lg, xl }">
            <v-menu v-if="mode == 'menu'" offset-y>
                <v-img slot="activator" slot-scope="{ attrs, on }" :aspect-ratio="1 / 1" :src="src" v-bind="attrs" v-on="on" @mouseover="$emit('mouseover', file)" />
                <v-list>
                    <v-list-item @click="remove(file)" class="font-size-14">삭제하기</v-list-item>
                </v-list>
            </v-menu>
            <v-hover v-if="mode == 'hover'" v-slot="{ hover }">
                <v-img :aspect-ratio="1 / 1" :src="src" content-class="d-flex align-center justify-center" @mouseover="$emit('mouseover', file)">
                    <v-fade-transition>
                        <v-btn icon color="black" v-show="hover" @click="remove(file)">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </v-fade-transition>
                </v-img>
            </v-hover>
        </v-col>
        <v-col slot="footer" v-show="showsAddButton" v-bind="{ cols, sm, md, lg, xl }">
            <v-responsive :aspect-ratio="1 / 1">
                <v-btn tile fab color="grey lighten-2" width="100%" height="100%" @click="onClick">
                    <v-icon :size="addIconSize" color="primary">mdi-plus</v-icon>
                </v-btn>
            </v-responsive>
            <v-file-input v-show="false" ref="file-input" accept="image/*" @change="onChange" />
        </v-col>
    </draggable>
</template>

<script>
import Draggable from "vuedraggable";
export default {
    components: {
        Draggable,
    },
    props: {
        cols: { type: [String, Number], default: "3" },
        sm: { type: [String, Number], default: undefined },
        md: { type: [String, Number], default: undefined },
        lg: { type: [String, Number], default: undefined },
        xl: { type: [String, Number], default: undefined },
        mode: { type: String, default: "menu" },
        value: { type: Array, default: () => [] },
        maxLength: { type: String, default: "0" },
        addIconSize: { type: String, default: "50" },
    },
    data: () => ({
        files: [],
    }),
    computed: {
        images() {
            return this.files.map((file) => ({ file, src: file instanceof File ? URL.createObjectURL(file) : file?.url }));
        },
        showsAddButton() {
            let { maxLength } = this;
            maxLength = +maxLength;
            if (maxLength == 0) return true;
            if (maxLength < 0) return false;
            return (this.files || [])?.length < maxLength;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.files = [...(this.value || [])];
        },
        emit() {
            this.$emit("input", this.files);
        },
        onClick() {
            this.$refs["file-input"]?.$el?.getElementsByTagName("input")?.[0]?.click();
        },
        onChange(file) {
            const { name } = file || {};
            const names = (this.files || []).map(({ name }) => name);

            if (names.includes(name)) alert("동일한 이름의 파일이 있습니다.");
            else {
                this.files = [...this.files, file];
                this.emit();
            }
        },
        remove(file) {
            if (!confirm("이미지를 삭제하시겠습니까?")) return;
            this.files = [...this.files.filter((item) => item !== file)];
            this.emit();
        },
    },
};
</script>
